import 'src/javascripts/vendor/typeahead.jquery';
import 'src/javascripts/vendor/bloodhound';
import {noResultsTemplate, emptyTemplate, genericDisplayTemplate, causeTemplate, logoTemplate, screenTemplate} from 'src/javascripts/components/typeaheads/TypeaheadTemplates';

// Must define Bloodhound explicitly here
// https://stackoverflow.com/questions/30750916/how-to-reference-typeahead-and-bloodhound-when-loading-npm-typeahead-js
const Bloodhound = require('src/javascripts/vendor/bloodhound');

var screens = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/companies/screens/search.json?screen_version=strict&query=%QUERY',
    wildcard: "%QUERY"
  }
});
screens.initialize();

// Screens typeahead
export const screensTypeahead = function() {
  $('#screens_typeahead').typeahead({
    hint: true,
    highlight: true,
    minLength: 0
  }, {
    source: screens,
    name: "name",
    display: "name",
    limit: 332,
    templates: {
      empty: emptyTemplate,
      suggestion(el) {
        if (el.name === null) {
          return noResultsTemplate();
        } else {
          return screenTemplate(el.name, el.fa_key);
        }
      }
    }
  });
}

var screensLite = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/companies/screens/search.json?screen_version=lite&query=%QUERY',
    wildcard: "%QUERY"
  }
});
screens.initialize();

// Screens typeahead
export const screensLiteTypeahead = function() {
  $('#screens_lite_typeahead').typeahead({
    hint: true,
    highlight: true,
    minLength: 0
  }, {
    source: screensLite,
    name: "name",
    display: "name",
    limit: 332,
    templates: {
      empty: emptyTemplate,
      suggestion(el) {
        if (el.name === null) {
          return noResultsTemplate();
        } else {
          return screenTemplate(el.name, el.fa_key);
        }
      }
    }
  });
}

var screenSets = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/companies/screen_sets/search.json?query=%QUERY',
    wildcard: "%QUERY"
  }
});
screenSets.initialize();

// Screens typeahead
export const screenSetsTypeahead = function() {
  $('#screen_sets_typeahead').typeahead({
    hint: true,
    highlight: true,
    minLength: 0
  }, {
    source: screenSets,
    name: "name",
    display: "name",
    limit: 332,
    templates: {
      empty: emptyTemplate,
      suggestion(el) {
        if (el.name === null) {
          return noResultsTemplate();
        } else {
          return screenTemplate(el.name, el.fa_key);
        }
      }
    }
  });
}


// Company bloodhounds
export const companiesBloodhound = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/research?query=%QUERY',
    wildcard: "%QUERY",
    transform: function(d) { return d.companies; }
  }
});

// Fund bloodhounds
export const fundsBloodhound = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/research?query=%QUERY',
    wildcard: "%QUERY",
    transform: function(d) { return d.funds; }
  }
});

// Brand bloodhounds
export const brandsBloodhound = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: '/companies/search?query=%QUERY',
    wildcard: "%QUERY",
    transform: function(d) { return d.brands; }
  }
});

// Initiate filter typeaheads
export const filterTypeahead = function(klass, name, url, limit, template) {
  let urlQuery;
  if (url[url.length - 1] !== '?') {
    urlQuery = url + '&query='
  } else {
    urlQuery = url + 'query='    
  }
  let bloodhound = new Bloodhound({
    datumTokenizer: Bloodhound.tokenizers.obj.whitespace('name'),
    queryTokenizer: Bloodhound.tokenizers.whitespace,
    remote: {
      url: urlQuery + '%QUERY',
      wildcard: "%QUERY"
    }});
  bloodhound.initialize();
  $(klass).typeahead({
    hint: true,
    highlight: true,
    minLength: 0,
  }, {
    name: name,
    display: 'name',
    source: bloodhound,
    limit: limit,
    templates: {
      empty: emptyTemplate,
      suggestion(el) {
        if (el.value === null) {
          return noResultsTemplate();
        } else {
          if (template === 'generic') {
            if (typeof el.name !== 'undefined') {
              return genericDisplayTemplate(el.name);
            } else {
              return genericDisplayTemplate(el.value);
            }
          } else if (template === 'exchange') {
            return genericDisplayTemplate(el.name_display);
          } else if (template === 'cause') {
            return causeTemplate(el.name, el.name_short, el.fa_key, el.value);
          } else if (template === 'logo') {
            return logoTemplate(el.name, el.symbol, el.logo_url, el.value);              
          }
        }
      },
    }
  });
} 

